export const MAIL_FORMAT = /^\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/;
export const PWD_FORMAT = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{6,}$/;
